import React from "react";

const Unauthorized: React.FC = () => {
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        height: "100vh",
        width: "100%",
        textAlign: "center",
        gap: "0.75rem",
        backgroundColor: "var(--surface-ground)",
      }}
    >
      <i className="pi pi-lock" style={{ fontSize: "2.5rem", color: "var(--text-color)" }} />
      <h2 style={{ margin: 0, color: "var(--text-color)" }}>Access Denied</h2>
      <p style={{ margin: 0, color: "var(--text-color)", maxWidth: "28rem" }}>
        You don&apos;t have permission to view this page. If you believe this is a
        mistake, please contact your administrator.
      </p>
    </div>
  );
};

export default Unauthorized;
